import { Expose } from 'class-transformer';

export class Address {
  @Expose()
  addressLine: string;

  @Expose()
  city: string;

  @Expose()
  state: string;

  @Expose()
  postCode: string;

  @Expose()
  country: string;

  clear() {
    this.addressLine = '';
    this.city = '';
    this.state = '';
    this.postCode = '';
    this.country = '';
  }
}
